import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=ed235342&scoped=true&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"
import style0 from "./swiper.vue?vue&type=style&index=0&id=ed235342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed235342",
  null
  
)

export default component.exports